import React from "react";

//Component ========== 
import Hidden from '@material-ui/core/Hidden';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';

//Question Component ==========    
import Button from "components/CustomButtons/Button.jsx"

import NavigateNextIcon from "@material-ui/icons/NavigateNext"
import NavigateBeforeIcon from "@material-ui/icons/NavigateBefore"

import withStyles from "@material-ui/core/styles/withStyles";

import wordingIntro from "configs/wordingIntro.jsx"
import LogoImage from "assets/img/mocap_logo.png";
// import LogoImage from "assets/img/nissan_logo.png";
import bgImage_dasktop from "assets/img/wallpaper-r1.png";
import bgImage_devices from "assets/img/wallpaper-r1.png";

import sidebarStyle from "assets/jss/material-dashboard-pro-react/components/sidebarStyle.jsx";

const wording = {
  text_btn_e: {
    th: "จบแบบสอบถาม",
    en: "Finish",
  },
  text_btn: {
    th: "เริ่มทำแบบสอบถาม",
    en: "Start the questionnaire",
  },
  text_btn_b: {
    th: "ย้อนกลับ",
    en: "Back Page",
  }
}
const styles = {
  ...sidebarStyle,
  inFullPage: {
    minHeight: "100vh",
    color: "#fff !important",
    alignItems: "center",
    backgroundSize: "cover",
    backgroundPosition: "center center",
    height: "100%",
  }
}
class introPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      language: this.props.language,
      // customerData:this.props.customerData
    }
  }
  handleChangeSelect = name => value => {
    this.setState({
      [name]: value,
    });
  };
  convertIntroText = (text) => {
    var _text = text
    _text = _text.replace("<?[{customer_fullname}]?>", this.props.customer_fullname)
    _text = _text.replace("<?[{user_login_fullname}]?>", this.props.user_login_fullname)
    _text = _text.replace("<?[{close_case_date}]?>", this.props.close_case_date)
    return _text
  }
  render() {
    const { classes, customerData, saveAndChangePage } = this.props;
    return (
      <div>
        <Hidden xsDown>
          <div
            className={classes.inFullPage + " survey-bg"}
            style={{ backgroundImage: "url(" + bgImage_dasktop + ")" }}
          >
            <div>-</div>

            <div className={"logo-intro-dasktop"}>
              <center>
                <img src={LogoImage} alt="thx-img" className="intro-img thx-img" />
              </center>
            </div>
            <div className="intro-card-customer-2">
              <Paper className="card-intro-1 card-intro-nmt-dasktop">
                <h3 ><center>ยินดีต้อนรับ {this.props.customerData.user_data_id.first_name + " " + this.props.customerData.user_data_id.last_name}</center></h3>
                <h4 ><center>เข้าสู่ การเลือกตั้งมัคนายก คริสตจักรไมตรีจิตสวนสยาม ปี 2022</center></h4>
                <span ><center>จงทำเครื่องหมาย / (ถูก) หน้ารายชื่อที่ต้องการเลือกจำนวน 6 ท่าน</center></span>
                <br />
                {this.props.children}
                <center>
                  <Button
                    round
                    color="success"
                    className={"btn-next"}
                    onClick={e => saveAndChangePage(1)}
                  >
                    ยืนยันการเลือก
                    <NavigateNextIcon className={classes.icons} />
                  </Button>
                </center>
              </Paper>
            </div>
          </div>
        </Hidden>
        <Hidden smUp>
          <div
            className={classes.inFullPage + " survey-bg"}
            style={{ backgroundImage: "url(" + bgImage_devices + ")" }}
          >
            <div>-</div>
            <center>
              <div className={"logo-intro-devices"}>
                <center>
                  <img src={LogoImage} alt="thx-img" className="intro-img thx-img" />
                </center>
              </div>
            </center>
            <div className="intro-card-customer-1">
              <Paper className="card-intro-devices card-intro-nmt-devices">
                <h3 ><center>ยินดีต้อนรับ {this.props.customerData.user_data_id.first_name + " " + this.props.customerData.user_data_id.last_name}</center></h3>
                <h4 ><center>เข้าสู่ การเลือกตั้งมัคนายก <br />คริสตจักรไมตรีจิตสวนสยาม ปี 2022</center></h4>
                <span ><center>จงทำเครื่องหมาย / (ถูก) หน้ารายชื่อที่ต้องการเลือกจำนวน 6 ท่าน</center></span>
                <br />
                {this.props.children}
                <center>
                  <Button
                    round
                    color="success"
                    className={"btn-next"}
                    onClick={e => saveAndChangePage(1)}
                  >
                    ยืนยันการเลือก
                    <NavigateNextIcon className={classes.icons} />
                  </Button>
                </center>
                <br />
                <br />
              </Paper>
            </div>
          </div>
        </Hidden>
      </div>
    );
  }
}
export default withStyles(styles)(introPage)